
export class NumberHelper {

    public static pad2(number: any) {
        return (number < 10 ? "0" : "") + number;
    }

    public static round(number: number, precision: number): number {

        if (!number) {
            return number;
        }

        if (typeof number !== 'number') {
            throw new TypeError('Expected value to be a number');
        }

        if (precision > 14) {
            return number;
        }

        if (!Number.isInteger(precision)) {
            throw new TypeError('Expected precision to be an integer');
        }

        const isRoundingAndNegative = number < 0;
        if (isRoundingAndNegative) {
            number = Math.abs(number);
        }

        const power = 10 ** precision;

        let result = Math.round(Number((number * power).toPrecision(15))) / power;

        if (isRoundingAndNegative) {
            result = -result;
        }

        //if -0 then just set it to 0.
        if (Math.abs(result) < Number.EPSILON) {
            result = 0;
        }

        return result;
    }

    public static getFormattedValue(value: number | string, culture: string = navigator.language, maximumFractionDigits: number = 2, fallBackValue: number = 0, startLabel: string = "", minimumFractionDigits: number = null): string {

        //make sure value is a number if defined
        if (typeof value == "string") {
            value = Number(value);
        }

        //make sure fallBackValue is a number if defined
        if (typeof fallBackValue == "string") {
            fallBackValue = Number(fallBackValue);
        }

        //default to navigator.language and then to uk if culture not provided
        if (!culture) {
            culture = navigator.language || "en-UK";
        }

        if (minimumFractionDigits == null || minimumFractionDigits < 0) minimumFractionDigits = (maximumFractionDigits ? maximumFractionDigits : 0);
        if (maximumFractionDigits == null) maximumFractionDigits = 15;

        const options = { minimumFractionDigits: minimumFractionDigits, maximumFractionDigits: maximumFractionDigits };

        // apply fallback if value is not defined
        if (value == null || value == undefined) {
            value = fallBackValue;
        }

        let formattedNumber = "";
        let isNegative = false;
        if (value != null && value !== undefined) {

            value = NumberHelper.round(value, maximumFractionDigits);

            isNegative = value < 0;
            formattedNumber = (isNegative ? -value : value).toLocaleString(culture, options);
        }

        if (formattedNumber) {
            return (isNegative ? "-" : "") + (startLabel || "") + formattedNumber;
        }

        return formattedNumber;
    }
}
